var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.776 2.025Q1.884 2.001 2 2h8q.115 0 .225.025L6 5.827zm-.734.686A1 1 0 0 0 1 3v6a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V3a1 1 0 0 0-.042-.29L6.535 6.692a.8.8 0 0 1-1.07 0zM0 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z",
    clipRule: "evenodd"
  })));
});
const SvgMailsmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMailsmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xLjc3NTU0IDIuMDI1MjlDMS44NDc2OSAyLjAwODc0IDEuOTIyODMgMiAyIDJIMTBDMTAuMDc3MiAyIDEwLjE1MjMgMi4wMDg3NCAxMC4yMjQ1IDIuMDI1MjlMNiA1LjgyNzMxTDEuNzc1NTQgMi4wMjUyOVpNMS4wNDI0NCAyLjcxMDg2QzEuMDE0ODQgMi44MDI0IDEgMi44OTk0NyAxIDNWOUMxIDkuNTUyMjggMS40NDc3MiAxMCAyIDEwSDEwQzEwLjU1MjMgMTAgMTEgOS41NTIyOSAxMSA5VjNDMTEgMi44OTk0NyAxMC45ODUyIDIuODAyNCAxMC45NTc2IDIuNzEwODZMNi41MzUxNyA2LjY5MTAxQzYuMjMwOTMgNi45NjQ4MyA1Ljc2OTA3IDYuOTY0ODMgNS40NjQ4MyA2LjY5MTAxTDEuMDQyNDQgMi43MTA4NlpNMCAzQzAgMS44OTU0MyAwLjg5NTQzMSAxIDIgMUgxMEMxMS4xMDQ2IDEgMTIgMS44OTU0MyAxMiAzVjlDMTIgMTAuMTA0NiAxMS4xMDQ2IDExIDEwIDExSDJDMC44OTU0MzEgMTEgMCAxMC4xMDQ2IDAgOVYzWiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";